import { filterOptions } from '../data/mockData';

const TAGMeFilters = ({
  selectedCategories,
  selectedMajors,
  selectedTags,
  onCategoryToggle,
  onMajorToggle,
  onTagToggle,
}) => {
  return (
    <div className='hidden lg:block lg:w-64 flex-shrink-0'>
      <div className='bg-gray-50 p-6 rounded-none border-t-0 border-b-0 border-l-0 border-r border-black'>
        <h3 className='text-lg font-semibold text-gray-900 mb-4'>Filters</h3>

        {/* Category Filter */}
        <div className='mb-6'>
          <h4 className='text-base font-bold text-white mb-3 text-right uppercase bg-black px-3 py-2 -mx-6'>
            Category
          </h4>
          <div className='space-y-2'>
            {filterOptions.categories.map(category => (
              <label
                key={category.id}
                className='flex items-center justify-end px-2 py-1 rounded cursor-pointer hover:bg-purple-500 hover:text-white transition-colors duration-200'
              >
                <span className='mr-2 text-sm'>{category.name}</span>
                <input
                  type='checkbox'
                  checked={selectedCategories.includes(category.id)}
                  onChange={() => onCategoryToggle(category.id)}
                  className='h-4 w-4 text-purple-500 focus:ring-purple-500 border-gray-300 rounded'
                />
              </label>
            ))}
          </div>
        </div>

        {/* Major Filter */}
        <div className='mb-6'>
          <h4 className='text-base font-bold text-white mb-3 text-right uppercase bg-black px-3 py-2 -mx-6'>
            Major
          </h4>
          <div className='space-y-2'>
            {filterOptions.majors.map(major => (
              <label
                key={major.id}
                className='flex items-center justify-end px-2 py-1 rounded cursor-pointer hover:bg-purple-500 hover:text-white transition-colors duration-200'
              >
                <span className='mr-2 text-sm'>{major.name}</span>
                <input
                  type='checkbox'
                  checked={selectedMajors.includes(major.id)}
                  onChange={() => onMajorToggle(major.id)}
                  className='h-4 w-4 text-purple-500 focus:ring-purple-500 border-gray-300 rounded'
                />
              </label>
            ))}
          </div>
        </div>

        {/* Tags Filter */}
        <div>
          <h4 className='text-base font-bold text-white mb-3 text-right uppercase bg-black px-3 py-2 -mx-6'>
            Tags
          </h4>
          <div className='flex flex-wrap gap-2'>
            {filterOptions.tags.map(tag => (
              <button
                key={tag.id}
                onClick={() => onTagToggle(tag.id)}
                className={`px-3 py-1 text-xs rounded-full transition-colors duration-200 ${
                  selectedTags.includes(tag.id)
                    ? 'bg-purple-500 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {tag.name}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TAGMeFilters;
